<template>
  <b-card no-body class="dashboard-card" border-variant="primary">
    <b-card-header class="card-header-text" header-bg-variant="primary" header-text-variant="white">
      <span class="spacer"/>
      <span v-if="singleCustomerSelected" class="info-text">{{ selectedCustomer.name }} {{ $t('sustainability_dashboard_ui.sustainability_score') }}</span>
      <span v-else class="info-text">{{ $t('sustainability_dashboard_ui.overall_sustainability_score') }}</span>
      <info-modal
        class="align-self-center"
        size="xl"
        :title="$t('sustainability_dashboard_ui.modal_info.sustainability_score.title')"
        :text="$t('sustainability_dashboard_ui.modal_info.sustainability_score.text')"/>
    </b-card-header>
    <b-card-body class="score-container">
      <div v-if="loading" class="d-flex align-items-center justify-content-center" style="height: 225px">
        <b-spinner variant="primary" type="grow" style="width: 4rem; height: 4rem;"/>
      </div>
      <div v-else class="d-flex align-items-center flex-column mt-2" style="height: 225px">
        <radial-meter ref="meter" :color="color" :width=220 :track-width=18>
          <span :style="`color: ${color}`">
            <font-awesome-icon size="5x" :icon="icon" class="mb-2"/>
          </span>
        </radial-meter>
        <h4 class="mb-2 font-weight-bold" :style="`color: ${color}`" style="font-size: 5rem">
          <span class="percent-value" v-if="sustainabilityScore">
            N/A
          </span>
          <span v-else>?</span>
        </h4>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import InfoModal from '@/components/shared/InfoModal'
import RadialMeter from '@/components/shared/RadialMeter'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'

export default {
  name: 'SustainabilityScore',
  components: {
    InfoModal,
    RadialMeter
  },
  mixins: [
    CurrentUserMixin
  ],
  props: {
    loading: null,
    sustainabilityScore: null,
    singleCustomerSelected: null,
    selectedCustomer: null
  },
  computed: {
    /**
     * The font awesome icon used in the radial meter
     * @returns {string}
     */
    icon () {
      if (this.sustainabilityScore >= 50) {
        return 'check'
      } else if (this.sustainabilityScore >= 25) {
        return 'exclamation-triangle'
      } else {
        return 'exclamation-triangle'
      }
    },
    /**
     * The text and track color used in the score
     * @returns {string}
     */
    color () {
      if (this.sustainabilityScore >= 50) {
        return '#5ecb21'
      } else if (this.sustainabilityScore >= 25) {
        return '#f0ad4e'
      } else {
        return '#dc2424'
      }
    }
  },
  methods: {
    triggerAnimation () {
      this.$nextTick(function () {
        this.$refs.meter.runTransition(this.sustainabilityScore)
      })
    }
  },
  watch: {
    loading () {
      if (this.loading === false) {
        this.triggerAnimation()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.score-container {
  min-height: 270px;
}
</style>
